import { Ach, AdyenCheckout, Card } from "@adyen/adyen-web";
import "@adyen/adyen-web/styles/adyen.css";
import "@adyen/kyc-components/styles.css";
import { RefObject, useEffect, useRef, useState } from "react";
import { PaymentSessionQuery } from "src/api/Payment";
import { UpsertStripeCustomerMutation } from "src/api/Stripe";
import { CreditCardType } from "src/components/forms/CreditCardIcon";
import Loading from "src/components/layout/Loading";
import { apiClient } from "src/stores/Api";
import { useSession } from "src/stores/Session";
import { useStore } from "src/stores/Store";
import "src/styles/adyen.css";
import colors from "src/utils/colors";
import tw from "src/utils/tw";
import {
  PaymentSessionType,
  upsertStripeCustomer,
  upsertStripeCustomerVariables,
} from "types/code-generator";

interface Props {
  user: {
    id: string;
  };
  adyenContainer: RefObject<any>;
  onReceiveToken: (
    payload: upsertStripeCustomer["upsertStripeCustomer"]
  ) => void;
  ach?: boolean;
  onError: (error: any) => void;
}

export function AdyenPaymentForm(props: Props) {
  const store = useStore();
  const session = useSession();
  const container = useRef(null);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setupCheckout();
  }, []);

  async function setupCheckout() {
    const paymentSessionQuery = await apiClient(PaymentSessionQuery, {
      variables: {
        data: {
          type: PaymentSessionType.Checkout,
        },
      },
    });

    const checkout = await AdyenCheckout({
      session: {
        id: paymentSessionQuery.paymentSession.id,
        sessionData: paymentSessionQuery.paymentSession.sessionData,
      },
      environment: process.env.STAGE === "prod" ? "live" : "test",
      clientKey: process.env.NEXT_PUBLIC_ADYEN_CLIENT,
      onPaymentCompleted: (response, _component) => {
        console.log("response", response);
      },
      onError: (error, _component) => {
        console.log("AdyenCheckout e", error);

        if (props.onError) {
          props.onError(error);
        }
      },
      onSubmit: async (state, component, actions) => {
        console.log("state", state, props.user);
        const accountOwner = props.user || session.accountOwner;

        if (state.isValid) {
          const variables: upsertStripeCustomerVariables = {
            data: {
              userId: accountOwner.id,
              organizationId: store.organization.id,
              adyenToken: {
                brand:
                  state.data.paymentMethod.brand ||
                  CreditCardType["Bank Account"],
                encryptedCardNumber:
                  state.data.paymentMethod.encryptedCardNumber,
                encryptedExpiryMonth:
                  state.data.paymentMethod.encryptedExpiryMonth,
                encryptedExpiryYear:
                  state.data.paymentMethod.encryptedExpiryYear,
                encryptedSecurityCode:
                  state.data.paymentMethod.encryptedSecurityCode,
                accountHolderType: state.data.paymentMethod.accountHolderType,
                bankAccountNumber: state.data.paymentMethod.bankAccountNumber,
                bankAccountType: state.data.paymentMethod.bankAccountType,
                bankLocationId: state.data.paymentMethod.bankLocationId,
                ownerName: state.data.paymentMethod.ownerName,
                checkoutAttemptId: state.data.paymentMethod.checkoutAttemptId,
              },
            },
          };

          try {
            const upsertAdyenCustomer = await apiClient(
              UpsertStripeCustomerMutation,
              {
                variables,
              }
            );

            console.log("upsertAdyenCustomer", upsertAdyenCustomer);

            props.onReceiveToken(upsertAdyenCustomer.upsertStripeCustomer);
          } catch (e) {
            if (props.onError) {
              props.onError(e);
            }
          }
        }
      },
    });

    if (props.ach) {
      if (container.current) {
        const achElement = new Ach(checkout, {
          showPayButton: false,
        }).mount(container.current);

        setMounted(true);

        if (props.adyenContainer) {
          props.adyenContainer.current = achElement;
        }
      }
    } else {
      if (container.current) {
        const card = new Card(checkout, {
          styles: {
            base: {
              fontFamily: '"soleil", sans-serif',
              color: colors.dark,
            },
          },
          showPayButton: false,
          enableStoreDetails: true,
        }).mount(container.current);

        setMounted(true);

        if (props.adyenContainer) {
          props.adyenContainer.current = card;
        }
      }
    }
  }

  return (
    <div className="max-w-prose">
      <div className={tw(mounted && "hidden")}>
        <Loading />
      </div>
      <div ref={container} className="payment"></div>
    </div>
  );
}
